var exports = {
  "M": "xcc377c0b--822ed8--promos-list",
};

module.exports = exports;
